module.exports = __webpack_public_path__ + "static/media/horse_on_window.ece0926c.gif";